// extracted by mini-css-extract-plugin
module.exports = {"list":"Dropdown-module__list___yM2V1","closed":"Dropdown-module__closed___JMbyi","above":"Dropdown-module__above___GxcBI","selected":"Dropdown-module__selected___y5da0"};